export const getAutoLinkMatchs = (value: string = "") => {
  const urlRegex =
    /(\b(https?):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return urlRegex.exec(value);
};
